import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from "react-toastify";


import * as settingsActions from "store/entities/settingsInfo/action";

import FormDrawer from '../form-drawer';


const DeactivateUserModal = (props) => {
const {isOpen, setIsOpen, data: member, getAllTeamMembers} = props;
const dispatch = useDispatch()
const {deactivateMember, deactivateMemberLoading} = useSelector(state => state.entities.settingsInfo)

const [isDeleted, setIsDeleted] = useState(false)

const handleDeactivateTeamMember = () => {
    dispatch(settingsActions.deactivateMember(member?.id))
    setIsDeleted(true)
}

useEffect(() => {
    if(deactivateMember?.error === false && isDeleted ){
        getAllTeamMembers()
        toast(deactivateMember?.message)
        setIsOpen(false)
        setIsDeleted(false)
        
    }
    // eslint-disable-next-line
}, [deactivateMember?.error, isDeleted]);

    return (
    
    <FormDrawer display="center" size="sm" isOpen={isOpen} setIsOpen={setIsOpen}>
            <div className="p-6">
                <FormDrawer.Title
                    title="Deactivate Team Member"
                    showCloseButton={true}
                    close={setIsOpen}
                />
                
                <div className='mt-4'>           
                    <div className='my-8'>Are you sure you want to perform this action?</div>
                    <div className="p-1 mt-4 flex justify-end space-x-3">
                        <button loading={deactivateMemberLoading} onClick={handleDeactivateTeamMember} type="button" className="btn btn-lg w-full rounded-lg whitespace-nowrap border text-white bg-ep-danger">
                            Yes
                        </button>
                        <button onClick={() => setIsOpen(false)} type="button" className="btn btn-lg w-full rounded-lg whitespace-nowrap border border-ep-primary-600 text-ep-primary-600 bg-white">
                            No
                        </button>
                    </div>     
                </div>
            </div>
    </FormDrawer>
  )
}

export default DeactivateUserModal